const ABSOLUTE_URL = /^(?:https?:\/\/|\/\/|data:|blob:)/i;

export const resolveAssetUrl = (assetsUrl: string, asset: string): string =>
  ABSOLUTE_URL.test(asset)
    ? asset
    : `${assetsUrl.replace(/\/+$/, "")}/${asset.replace(/^\/+/, "")}`;
